import script from "./ShippingDocumentsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ShippingDocumentsTable.vue?vue&type=script&setup=true&lang=js"

import "./ShippingDocumentsTable.vue?vue&type=style&index=0&id=bdcfc3a0&lang=scss"

const __exports__ = script;

export default __exports__